import Sortable from "sortablejs"

export function sortable(node, options) {
  const instance = new Sortable(node, options)

  return {
    destroy() {
      instance.destroy()
    },
  }
}
